import React from "react";

interface Props {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  strokeWidth?: number;
}

export function IconCopyOutline(props: Props) {
  const {
    width = 24,
    height = 24,
    color = "#0B0A0F",
    strokeWidth = 1.5,
    className = "",
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M14.25 10.25V6.75C14.25 6.19772 13.8023 5.75 13.25 5.75H6.25C5.69772 5.75 5.25 6.19772 5.25 6.75V13.75C5.25 14.3023 5.69772 14.75 6.25 14.75H9.75M17.75 10.25H10.75C10.1977 10.25 9.75 10.6977 9.75 11.25V18.25C9.75 18.8023 10.1977 19.25 10.75 19.25H17.75C18.3023 19.25 18.75 18.8023 18.75 18.25V11.25C18.75 10.6977 18.3023 10.25 17.75 10.25Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
